export enum TABS {
  APP_AND_BROWSER = 'appAndBrowser',
  ROKU = 'roku',
}
